var _defs, _ellipse, _ellipse2, _ellipse3, _ellipse4, _circle, _path, _path2, _path3, _path4, _path5, _path6;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgSustainability(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 81 77",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 38.043,
    cy: 38.5,
    rx: 19.207,
    ry: 27.439,
    stroke: "#050505"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 38.042,
    cy: 38.5,
    rx: 8.232,
    ry: 27.439,
    stroke: "#050505"
  })), _ellipse3 || (_ellipse3 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 38.043,
    cy: 38.5,
    rx: 19.207,
    ry: 27.439,
    transform: "rotate(90 38.043 38.5)",
    stroke: "#050505"
  })), _ellipse4 || (_ellipse4 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 38.043,
    cy: 38.5,
    rx: 8.232,
    ry: 27.439,
    transform: "rotate(90 38.043 38.5)",
    stroke: "#050505"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 38.5,
    cy: 38.5,
    r: 27.439,
    stroke: "#050505"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M75.999 39.007C75.999 18.017 58.983 1 37.992 1",
    stroke: "#03BCAA",
    strokeDasharray: "2.74 2.74"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M71.945 35.966L76 39.006l4.054-3.04",
    stroke: "#03BCAA",
    strokeMiterlimit: 2.613
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M19.91 70.883c18.178 10.495 41.423 4.267 51.918-13.911",
    stroke: "#03BCAA",
    strokeDasharray: "2.74 2.74"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M24.57 68.893l-4.66 1.99.606 5.031",
    stroke: "#03BCAA",
    strokeMiterlimit: 2.613
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M20.349 6.37C2.17 16.866-4.058 40.11 6.437 58.29",
    stroke: "#03BCAA",
    strokeDasharray: "2.74 2.74"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M19.742 11.401l.606-5.031-4.66-1.99",
    stroke: "#03BCAA",
    strokeMiterlimit: 2.613
  })));
}

var MemoSvgSustainability = /*#__PURE__*/React.memo(SvgSustainability);
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iODEiIGhlaWdodD0iNzciIHZpZXdCb3g9IjAgMCA4MSA3NyIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPGVsbGlwc2UgY3g9IjM4LjA0MzMiIGN5PSIzOC40OTk4IiByeD0iMTkuMjA3MyIgcnk9IjI3LjQzOSIgc3Ryb2tlPSIjMDUwNTA1Ii8+CjxlbGxpcHNlIGN4PSIzOC4wNDIzIiBjeT0iMzguNDk5OCIgcng9IjguMjMxNzEiIHJ5PSIyNy40MzkiIHN0cm9rZT0iIzA1MDUwNSIvPgo8ZWxsaXBzZSBjeD0iMzguMDQzNCIgY3k9IjM4LjQ5OTgiIHJ4PSIxOS4yMDczIiByeT0iMjcuNDM5IiB0cmFuc2Zvcm09InJvdGF0ZSg5MCAzOC4wNDM0IDM4LjQ5OTgpIiBzdHJva2U9IiMwNTA1MDUiLz4KPGVsbGlwc2UgY3g9IjM4LjA0MzQiIGN5PSIzOC40OTk5IiByeD0iOC4yMzE3MSIgcnk9IjI3LjQzOSIgdHJhbnNmb3JtPSJyb3RhdGUoOTAgMzguMDQzNCAzOC40OTk5KSIgc3Ryb2tlPSIjMDUwNTA1Ii8+CjxjaXJjbGUgY3g9IjM4LjQ5OTYiIGN5PSIzOC40OTk4IiByPSIyNy40MzkiIHN0cm9rZT0iIzA1MDUwNSIvPgo8cGF0aCBkPSJNNzUuOTk4OSAzOS4wMDY4Qzc1Ljk5ODkgMTguMDE2MiA1OC45ODI3IDEgMzcuOTkyMiAxIiBzdHJva2U9IiMwM0JDQUEiIHN0cm9rZS1kYXNoYXJyYXk9IjIuNzQgMi43NCIvPgo8cGF0aCBkPSJNNzEuOTQ1MyAzNS45NjYyTDc1Ljk5OTQgMzkuMDA2N0w4MC4wNTM0IDM1Ljk2NjIiIHN0cm9rZT0iIzAzQkNBQSIgc3Ryb2tlLW1pdGVybGltaXQ9IjIuNjEzMTMiLz4KPHBhdGggZD0iTTE5LjkwOTkgNzAuODgzMUMzOC4wODgzIDgxLjM3ODQgNjEuMzMyOCA3NS4xNSA3MS44MjgxIDU2Ljk3MTciIHN0cm9rZT0iIzAzQkNBQSIgc3Ryb2tlLWRhc2hhcnJheT0iMi43NCAyLjc0Ii8+CjxwYXRoIGQ9Ik0yNC41NzAzIDY4Ljg5MjZMMTkuOTEwMSA3MC44ODMyTDIwLjUxNjMgNzUuOTE0NCIgc3Ryb2tlPSIjMDNCQ0FBIiBzdHJva2UtbWl0ZXJsaW1pdD0iMi42MTMxMyIvPgo8cGF0aCBkPSJNMjAuMzQ4OSA2LjM3MDM4QzIuMTcwNTggMTYuODY1NyAtNC4wNTc3OCA0MC4xMTAyIDYuNDM3NSA1OC4yODg2IiBzdHJva2U9IiMwM0JDQUEiIHN0cm9rZS1kYXNoYXJyYXk9IjIuNzQgMi43NCIvPgo8cGF0aCBkPSJNMTkuNzQyMiAxMS40MDExTDIwLjM0ODMgNi4zNjk5NEwxNS42ODgxIDQuMzc5MyIgc3Ryb2tlPSIjMDNCQ0FBIiBzdHJva2UtbWl0ZXJsaW1pdD0iMi42MTMxMyIvPgo8L3N2Zz4K";
export { MemoSvgSustainability as ReactComponent };